export default {
  storePreferences(state, val) {
    state.preferences = val
  },
}
